import 'Styles/searchbar.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { pathToSearch } from 'Utils/nav/NavHelpers';
import { trackGAEvent } from 'Actions/adsActions';

import { resetInfinite } from 'Actions/InfiniteScrollActions';
import { resetSearch } from 'Actions/SearchResultActions';

import SvgIcon from 'Components/svg/SvgIcon'

class SearchBarComponent extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			searchQuery: '',
			forumId: null,
			scope: {
				showposts: 0
			}
		};
	}

	updateSearchQuery = ( e ) => {
		this.setState({
			searchQuery: e.target.value
		});
	};

	updateSearchForumid = ( e ) => {
		let forumId = parseInt( e.target.value );

		this.setState({
			forumId: ( forumId > 0 ? parseInt( this.props.forumId ) : null )
		});
	};

	updateFetchScope = ( e ) => {
		this.setState({
			...this.state,
			scope: {
				showposts: parseInt( e.target.value )
			}
		});
	};

	clearInput = () => {
		this.setState({
			searchQuery: '',
			forumId: null
		});
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'forumSearchClear', 'uiAction', 'cancel' ) );
	};

	handleSearch = ( event ) => {
		event.preventDefault();

		this.searchTextInput.blur();

		if( this.state.searchQuery ) {
			this.props.dispatch( resetInfinite() );
			this.props.dispatch( resetSearch() );

			let query = {
				q: this.state.searchQuery,
				showposts: ( this.state.scope.showposts === 0 ? 0 : 1 ),
				page: 1,
				refresh: ( /^#\/search/.test( document.location.hash ) ? 1 : null ) // if we are already on search add 'refresh' to querystring
			};
			if( this.state.forumId ) {
				query.forumid = this.state.forumId;
			}

			this.props.dispatch( push( {
				pathname: pathToSearch( 0 ),
				query: query
			} ) );
		}
	};

	render() {
		let opened = this.props.isOpen ? 'opened' : '',
			forumsDisabled = this.props.forumId && this.props.forumId > 0 ? '' : 'disabled';

		return (
			<form onSubmit={ this.handleSearch }>
				<div id="searchbar" className={ opened }>
					<div className="top">
						<div className="query">
							<input type="text"
								onChange={ this.updateSearchQuery }
								value={ this.state.searchQuery }
								placeholder="Search terms..."
								ref={ it => this.searchTextInput = it }
							/>
							<div className="clear" onClick={ this.clearInput }>
								<SvgIcon size="18px" icon="clear" />
							</div>
						</div>
						<div className="search" onClick={ this.handleSearch }>
							Search
						</div>
					</div>
					<div className="bottom">
						<span className="description">Search in the current</span>
						<div className="buttons">
							<label className={ forumsDisabled }>
								Forum
								<input
									disabled={ !!forumsDisabled }
									type="radio"
									name="searchtype"
									value="1"
									onChange={ this.updateSearchForumid }
									checked={ this.state.forumId > 0 }
								/>
							</label>
							<label>
								Everywhere
								<input
									type="radio"
									name="searchtype"
									value="0"
									onChange={ this.updateSearchForumid }
									checked={ this.state.forumId <= 0 || this.state.forumId === null }
								/>
							</label>
						</div>
					</div>
					<div className="bottom">
						<span className="description">and show me</span>
						<div className="buttons">
							<label>
								Posts
								<input type="radio"
									   name="showposts"
									   value="1"
									   checked={ this.state.scope.showposts === 1 }
									   onChange={ this.updateFetchScope } />
							</label>
							<label>
								Threads
								<input type="radio"
									   name="showposts"
									   value="0"
									   checked={ this.state.scope.showposts === 0 }
									   onChange={ this.updateFetchScope } />
							</label>
						</div>
					</div>
				</div>
			</form>
		);
	}
}

function mapStateToProps( state ) {
	return {
		forumId: state.forumview.forumId || ( state.searchresult.query && state.searchresult.query.forumId ? state.searchresult.query.forumId : null ),
		isOpen: state.ui.searchBarOpened
	}
}

SearchBarComponent.propTypes = {
	dispatch: PropTypes.func.isRequired
};

export default connect( mapStateToProps )( SearchBarComponent );



// WEBPACK FOOTER //
// ./src/components/header/SearchBarComponent.js